module.exports = __webpack_public_path__ + "img/upgrade_page_banner.b7ff1090.gif";